<div class="d-flex justify-content-center">
	<div class="progress mt-2" style="height: 5px;flex-grow: 5;">
		<div class="progress-bar" [ngStyle]="{'background-color':backgroundColor, 'width': scorePercent+'%' }" role="progressbar"
			aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
	</div>

</div>
<small class="form-text text-muted">
	Passwords should be 8-20 characters long, contain letters, numbers and special characters.
</small>